export const getSubscriptionStatus = (subscriptionDetail) =>
  parseInt(subscriptionDetail?.status, 10);

export const applyCancelledSubscriptionData = (data, { isAdminUser = false } = {}) => {
  if (!data?.subscriptionDetail) {
    return data;
  }

  const status = getSubscriptionStatus(data.subscriptionDetail);
  if (status !== 1) {
    return data;
  }

  return {
    ...data,
    subscriptionDetail: {
      ...data.subscriptionDetail,
      status: isAdminUser ? 0 : 2,
    },
  };
};

export const shouldKeepCancelledStatus = (currentStatus, nextStatus) =>
  nextStatus === 1 && (currentStatus === 2 || currentStatus === 0);

export const mergeSubscriptionData = (currentData, nextData) => {
  if (!nextData) {
    return currentData;
  }

  const currentStatus = getSubscriptionStatus(currentData?.subscriptionDetail);
  const nextStatus = getSubscriptionStatus(nextData.subscriptionDetail);

  if (shouldKeepCancelledStatus(currentStatus, nextStatus)) {
    return {
      ...nextData,
      subscriptionDetail: {
        ...nextData.subscriptionDetail,
        status: currentStatus,
      },
    };
  }

  return nextData;
};
